import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/react-hooks';
import Tooltip from '@material-ui/core/Tooltip';
import Moment from 'react-moment';
import { useState } from 'react';

import './crosssection.scss';
import Device from './Device';
import SST from './SST';
import PassiveComponent from './PassiveComponent/PassiveComponent';
import CrosssectionDetailDialog from './dialogs/CrosssectionDetailDialog'
import { GET_CROSSSECTION_DATA } from './crosssection.gql';

const DATA_POLL_INTERVAL = 1000;

const Crosssection = ({
  crosssection: {
    id,
    name,
    kilometer,
    lanes_count,
    past_invisible_lanes,
    next_invisible_lanes,
    ssts,
    devices,
    passive_components
  }
}) => {
  const [openCrosssectionDetailDialog, setOpenCrosssectionDetailDialog] = useState(false);

  if(ssts === undefined) {
    ssts = [];
  }

  if(devices === undefined) {
    devices = [];
  }
  
  if(passive_components === undefined) {
    passive_components = [];
  }

  const handleCrosssectionDetailDialogOpen = () => {
    setOpenCrosssectionDetailDialog(true);
  };

  const handleCrosssectionDetailDialogClose = () => {
    setOpenCrosssectionDetailDialog(false);
  };

  //dummy for lane iteration
  const lanes = new Array(lanes_count + past_invisible_lanes + next_invisible_lanes).fill(0);
  const visible_lanes = new Array(lanes_count).fill(1)
  Array.prototype.splice.apply(lanes, [past_invisible_lanes, visible_lanes.length].concat(visible_lanes))
  return (
    <React.Fragment>
    <CrosssectionDetailDialog
      crosssectionName = {name}
      crosssectionId={id}
      open={openCrosssectionDetailDialog}
      onClose={handleCrosssectionDetailDialogClose}
    />
    <div className='crossSection'>
        <div className='cs-label-top'>
          <div className='kilometer'>km {kilometer.toFixed(3)}</div>
        </div>
        <div className='beside-the-lane'>
            <div className='sst-area'>
              {ssts.map((sst) => {
                if(sst.position === "LEFT_OF_ROAD") {
                  return (<SST key={sst.name} source={sst}/>)
                }
                return null;
              })}
            </div>
            <div className='device-area-left'>
              {devices.map((device) => {
                if(device.position === "LEFT_OF_ROAD") {
                  return (<Device key={device.name} source={device} />)
                }
                return null;
              })}
              {passive_components.map((comp, i) => {
                if(comp.position === "LEFT_OF_ROAD") {
                  return (<PassiveComponent key={i} name={comp.name} type={comp.passive_component_type} link={comp.link}/>)
                }
                return null;
              })}
            </div>
        </div>
        {/* ________________________________________________________________________________________________________ */}
        <div className='lanes'>
          <div className='invisible_lanes'>
              {past_invisible_lanes!==0 && lanes.splice(0, past_invisible_lanes).map((lane,i) => {
                return (<div key={"ULANEP"+i} className='invisible_lane'/>);
              })}
          </div>
          <div>
            {lanes.map((lane, laneIndex) => {  
              return lane===1?(
                <div key={"LANE"+laneIndex} className='lane'>
                  {devices.map((device) => {
                    if(device.position === "LANE"+laneIndex) {
                      return (<Device key={device.name} source={device} />)
                    }
                    return null;
                  })}        
                </div>
              ):null;            
            })}
          </div>
          <div className='invisible_lanes'>
          {next_invisible_lanes!==0 && lanes.splice(lanes.length-next_invisible_lanes).map((lane, laneIndex) => {  
              return(<div key={"ULANEN"+laneIndex} className='invisible_lane'/>);            
            })
          }
          </div>
        </div> 
        {/* ________________________________________________________________________________________________________ */} 
        <div className='beside-the-lane'>
            <div className='device-area-right'>
              {devices.map((device) => {
                if(device.position === "RIGHT_OF_ROAD") {
                  return (<Device key={device.name} source={device} />)
                }
                return null;
              })}
              {passive_components.map((comp) => {
                if(comp.position === "RIGHT_OF_ROAD") {
                  return (<PassiveComponent key={comp.name} name={comp.name} type={comp.passive_component_type} link={comp.link}/>)
                }
                return null;
              })}
            </div>  
            <div className='sst-area'>
              {ssts.map((sst) => {
                if(sst.position === "RIGHT_OF_ROAD") {
                  return (<SST key={sst.name} source={sst}/>)
                }
                return null;
              })}
            </div>
        </div>
        <div className='cs-label-bottom'>
            <CrossSectionLabel name={name} crosssectionId={id} onClick={handleCrosssectionDetailDialogOpen}/>
            <div className='kilometer'>km {kilometer.toFixed(3)}</div>
        </div>
    </div>
    </React.Fragment>
  );
};

const CrossSectionLabel = props => {
  const { crosssectionId, name, onClick } = props;

  const { data: crosssectionDataResult } = useQuery(GET_CROSSSECTION_DATA, 
    {
      variables: { id: crosssectionId },
      pollInterval: DATA_POLL_INTERVAL,
      notifyOnNetworkStatusChange: true
    });
  let trafficSituation = 0;
  let trafficData = {
    qKfzG: -4, qLkwG: -4, qPkwG: -4,
    vKfzG: -4, vLkwG: -4, vPkwG: -4
  };

  if(crosssectionDataResult !== undefined) {
    if(crosssectionDataResult.crosssection.traffic_situation !== null && crosssectionDataResult.crosssection.traffic_data !== null) {
      trafficSituation = crosssectionDataResult.crosssection.traffic_situation.trafficSituation;
      trafficData = crosssectionDataResult.crosssection.traffic_data;
    }
  }

  if(trafficData.timestamp !== undefined) {
    return <Tooltip placement="top" title={
      <React.Fragment>
        <p><Moment format="DD.MM.YYYY HH:mm:ss">{trafficData.timestamp}</Moment></p>
        <p>{"qKfz: " + (trafficData.qKfzG === -4 ? "N/A" : trafficData.qKfzG  + " Fz/h")}</p>
        <p>{"qLkw: " + (trafficData.qLkwG === -4 ? "N/A" : trafficData.qLkwG  + " Fz/h")}</p>
        <p>{"qPkw: " + (trafficData.qPkwG === -4 ? "N/A" : trafficData.qPkwG  + " Fz/h")}</p>
        <p>{"vKfz: " + (trafficData.vKfzG === -4 ? "N/A" : trafficData.vKfzG + " km/h")}</p>
        <p>{"vLkw: " + (trafficData.vLkwG === -4 ? "N/A" : trafficData.vLkwG + " km/h")}</p>
        <p>{"vPkw: " + (trafficData.vPkwG === -4 ? "N/A" : trafficData.vPkwG + " km/h")}</p>
      </React.Fragment>}>
      <div onClick={onClick} className={"name level-" + trafficSituation}>{name}</div>
    </Tooltip>;
  } else {
    return <div onClick={onClick} className="name">{name}</div> 
  }
};

Crosssection.propTypes = {
    crosssection: PropTypes.object.isRequired
};

export default Crosssection;
